// 'My activity feed' scope preference (D-277). A per-device profile setting on
// /me (MePage) that sets the DEFAULT scope of the Home Recent Activity feed.
// Values match the server-side filter whitelist in
// netlify/functions/db.js (case 'get_recent_activity'):
//   'all'        — Me + Friends (default)
//   'just_me'    — Me only
//   'my_friends' — Friends only
//
// Persistence is client-side only (per-device localStorage; no DB column —
// this is D-269's view filter). HomePage reads this and passes it as `filter`
// to its existing get_recent_activity call. The All Rounds page
// (ActivityPage) keeps its OWN independent inline dropdown — it does NOT read
// or write this preference (owner checklist item 5).

const KEY = 'tf_activity_scope'
const VALID = ['all', 'just_me', 'my_friends']
const DEFAULT = 'all'

// Read the stored scope. Any value not in the allow-set (unset, garbage, an
// old/renamed value) coerces to the default 'all'.
export function readActivityScope() {
  try {
    const v = localStorage.getItem(KEY)
    return VALID.includes(v) ? v : DEFAULT
  } catch {
    return DEFAULT
  }
}

// Persist the scope. An invalid value is coerced to the default before writing
// so a bad caller can never store an out-of-contract string.
export function writeActivityScope(v) {
  const next = VALID.includes(v) ? v : DEFAULT
  try {
    localStorage.setItem(KEY, next)
  } catch {}
  return next
}

export const ACTIVITY_SCOPES = VALID
